export const firebaseConfig = {
  apiKey: "AIzaSyDgvzwH9PAxPVs0q0c2Bo-2t6-cVOTNsxk",
  authDomain: "stub-web.firebaseapp.com",
  databaseURL: "https://stub-web.firebaseio.com",
  projectId: "stub-web",
  storageBucket: "stub-web.appspot.com",
  messagingSenderId: "683517126557",
  appId: "1:683517126557:web:87b2b9c6edbeb4f6",
  measurementId: "G-2QFWT6ZPV0"
};